module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-yellow-b85732d21109f7348d95b85eac5a92e2.png";